import Vue from "vue";
import PageHeader from "@/components/PageHeader";
import PageFooter from "@/components/PageFooter";
import Popup from "@/components/Popup";
import Tab1 from "@/components/Tab1";
import Tab2 from "@/components/Tab2";
import Tab3 from "@/components/Tab3";
import Tab4 from "@/components/Tab4";
import Tab5 from "@/components/Tab5";
import Runway from "@/components/Runway";
import Worktemp from "@/components/Worktemp";
import SubNav from "@/components/SubNav";
import WorkcoverImg from "@/components/WorkcoverImg";
import WorkTwoImg from "@/components/WorkTwoImg";
import WorkThreeImg from "@/components/WorkThreeImg";
import Hire from "@/components/Hire";

Vue.component("PageHeader", PageHeader);
Vue.component("PageFooter", PageFooter);
Vue.component("Popup", Popup);
Vue.component("Tab1", Tab1);
Vue.component("Tab2", Tab2);
Vue.component("Tab3", Tab3);
Vue.component("Tab4", Tab4);
Vue.component("Tab5", Tab5);
Vue.component("Runway", Runway);
Vue.component("Worktemp", Worktemp);
Vue.component("SubNav", SubNav);
Vue.component("WorkcoverImg", WorkcoverImg)
Vue.component("WorkTwoImg", WorkTwoImg)
Vue.component("WorkThreeImg", WorkThreeImg)
Vue.component("Hire", Hire)